export default __webpack_public_path__ + "static/media/subscribe.07d0241a.svg";